import React from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme';
import tinycolor from 'tinycolor2';
import { startsWith, endsWith, isArray, trim } from 'lodash';

const _Cell = styled.g`
  user-select: none;
  cursor: pointer;
  
  &:hover {
    .cell {
      fill: ${props => tinycolor(props.background).darken(5).toString()};
    }
  }
  text {
    pointer-events: none;
    white-space: pre;
  }
`

class Cell extends React.PureComponent {

  render() {
    const {
      uid,
      cellPath,
      cellType,
      text='',
      textPath,
      date,
      manualOffset,
      reverse,
      fontSize,
      fontFamily,
      strokeWidth,
      strokeColor,
      fill,
      textColor,
      onClick,
      onDoubleClick,
    } = this.props;

    const mOffset = reverse ? -manualOffset : manualOffset;

    const showDate = endsWith(cellType, 'date');
    const multiline = endsWith(cellType, 'multiline');
    const vertical = startsWith(cellType, 'vertical');
    const inline = cellType.indexOf('inline') > -1;
    
    const lines = multiline ? text.split(/[ #\n]+/g) : text.split(/[#\n]+/g);
    const offset = -(lines.length - (showDate && !inline ? 0.5 : 1.5)) / 2;

    let dateDy = (offset + lines.length * 1.2 + manualOffset / 20) * fontSize;
    let textOffset = '50%';
    let textAnchor = 'middle';
    let dateOffset = '50%';
    let dateAnchor = 'middle';
    if(cellType === 'vertical-inline-date') {
      textOffset = reverse ? '93%' : '7%';
      textAnchor = reverse ? 'end' : 'start';
      dateOffset = reverse ? '7%' : '93%';
      dateAnchor = reverse ? 'start' : 'end';
      dateDy = (0.25 + mOffset / 20) * fontSize;
    }

    const isGradient = isArray(fill);

    const _fill = isGradient ? 'transparent' : fill;
    const _style = {};
    if(isGradient) {
      _style.fill = `url("#d-${uid}-gradient")`;
    }

    return (
      <_Cell background={_fill} onClick={onClick}>

        <defs>
          {isGradient && 
            <linearGradient id={`d-${uid}-gradient`} x1="0%" y1={uid === 2 ? "100%" : "0%"} x2="100%" y2={uid === 3 ? "100%" : "0%"}>
              <stop offset="0%" style={{stopColor: fill[0], stopOpacity: 1}}></stop>
              <stop offset="100%" style={{stopColor: fill[1], stopOpacity: 1}}></stop>
            </linearGradient>
          }
        </defs>

        <path className="cell" d={cellPath} fill={_fill} strokeWidth={strokeWidth} stroke={strokeColor} style={_style} />
        <path id={`d-${uid}`} d={textPath} stroke="none" fill="none" />
        
        {lines.map((line, i) => (
          <text x="0" y="0" style={{fontFamily, textAnchor: textAnchor, fontSize}} fill={textColor} key={i} dy={`${((offset + i) * 1.2 + mOffset / 20) * fontSize}px`}>
            <textPath xlinkHref={`#d-${uid}`} startOffset={textOffset}>
              <tspan>{trim(line.replace(/~/g, ' '))}</tspan>
            </textPath>
          </text>
        ))}

        {!showDate ? null : 
          <text dy={`${dateDy}px`} fontFamily={fontFamily} textAnchor={dateAnchor} fill={tinycolor(textColor).lighten(30).toString()} fontSize={fontSize}>
            <textPath xlinkHref={`#d-${uid}`} startOffset={dateOffset}>
              <tspan>{date}</tspan>
            </textPath>
          </text>
        }
      </_Cell>
    )
  }
}

export default Cell;


// WEBPACK FOOTER //
// ./src/components/cell/index.js